import type { CustomAnalyticsChart } from "@redotech/redo-analytics-common/reports/custom-analytics-chart";
import {
  RedoPieChart,
  type RedoPieChartSeriesDatum,
} from "@redotech/redo-web/arbiter-components/charts/pie-chart/redo-pie-chart";
import { memo, useMemo } from "react";

export const PieChartBody = memo(function PieChartBody({
  chart,
  formatValue,
}: {
  chart: CustomAnalyticsChart;
  formatValue: (value: number) => string;
}) {
  const series = useMemo<RedoPieChartSeriesDatum[]>(() => {
    const data = chart.series[0]?.data ?? [];
    return chart.labels.map((label, index) => ({
      label,
      value: data[index] ?? 0,
    }));
  }, [chart]);

  return (
    <RedoPieChart
      displayLabelValues
      series={series}
      size="sm"
      // The builder already orders slices and appends the "Other" bucket
      // last — re-sorting would shuffle "Other" into the middle.
      sort="none"
      valueFormatter={formatValue}
    />
  );
});
